module.exports = __webpack_public_path__ + "static/img/contant_8.e5478be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_8.jpg
// module id = hhG5
// module chunks = 0